import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { css } from '@emotion/core';
import { FormattedMessage } from 'react-intl';
import { Button } from 'antd';
import IconSvg from '../common/IconSvg';
import { UpgradePopoverText } from '../../containers/Header/styled';
import { colors } from '../../constants';
import { PageDisabledBlocker } from '../common/styled';

@inject('routingStore')
@inject('settingsStore')
@observer
class NoSubscriptionBlocker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      onCatalog: /^\/catalog/.test(window.location.pathname),
      onOrders: /^\/orders/.test(window.location.pathname),
      onReports: /^\/reports/.test(window.location.pathname),
      onLearningCenter: /^\/learning/.test(window.location.pathname),
      historyListener: null,
    };
  }

  componentDidMount() {
    this.initializeLocationListener();
  }

  componentWillUnmount() {
    const { historyListener } = this.state;
    if (historyListener) {
      historyListener();
    }
  }

  initializeLocationListener() {
    const {
      routingStore: { browserHistory },
    } = this.props;
    this.setState({
      historyListener: browserHistory.listen(location => {
        this.toggleOnCatalog(/^\/catalog/.test(location.pathname));
        this.toggleOnOrders(/^\/orders/.test(location.pathname));
        this.toggleOnReports(/^\/reports/.test(location.pathname));
        this.toggleOnLearningCenter(/^\/learning/.test(location.pathname));
      }),
    });
  }

  toggleOnOrders = force => {
    const { onOrders } = this.state;
    this.setState({ onOrders: typeof force === 'boolean' ? force : !onOrders });
  };

  toggleOnCatalog = force => {
    const { onCatalog } = this.state;
    this.setState({ onCatalog: typeof force === 'boolean' ? force : !onCatalog });
  };

  toggleOnReports = force => {
    const { onReports } = this.state;
    this.setState({ onReports: typeof force === 'boolean' ? force : !onReports });
  };

  toggleOnLearningCenter = force => {
    const { onLearningCenter } = this.state;
    this.setState({ onLearningCenter: typeof force === 'boolean' ? force : !onLearningCenter });
  };

  render() {
    const { onCatalog, onReports,onLearningCenter } = this.state;
    const {
      settingsStore: {
        subscription: {
          subscriptionInitialized,
          currentPlan,
          catalogAvailable,
          userHasCourse
        },
      },
      openSubscriptionSettings,
    } = this.props;

    let messageId = 'subscription.noPlan';
    if (subscriptionInitialized) {
      if (onCatalog) {
        if (catalogAvailable) {
          return null;
        }
        messageId = 'subscription.unavailable';
      } else if(onLearningCenter && userHasCourse){
        return null;
      }
      else if (currentPlan || onReports) {
        return null;
      }
    } else {
      return null;
    }

    return (
      <PageDisabledBlocker>
        <div
          css={css`
            margin: 0 auto;
            margin-top: 20px;
            width: 420px;
            height: 69px;
            line-height: 1;
            background: #ffffff;
            display: flex;
            flex-direction: row;
            margin-top: 20px;
            align-items: center;
            justify-content: center;
            border-radius: 10px;
            border: 2px solid ${colors.pinkDark};
          `}
        >
          <UpgradePopoverText>
            <FormattedMessage id={messageId} />
          </UpgradePopoverText>
          <Button
            type="primary"
            onClick={openSubscriptionSettings}
            size="large"
            css={css`
              border-radius: 20px;
              display: flex;
              align-items: center;
              margin-left: 10px;
            `}
          >
            <FormattedMessage id="subscription.upgradePlan" />
            <IconSvg
              css={css`
                margin-left: 7px;
              `}
              type="space-ship"
              size={25}
            />
          </Button>
        </div>
      </PageDisabledBlocker>
    );
  }
}

NoSubscriptionBlocker.propTypes = {
  settingsStore: PropTypes.object,
  routingStore: PropTypes.object,
  openSubscriptionSettings: PropTypes.func,
};

export default NoSubscriptionBlocker;
